import { Forward } from 'lucide-react'
import { Badge, ButtonIcon, DefaultTooltip, Progress } from 'twyne-new.ui'

import { useBulkPublish } from './context'

const STATUS = {
  pending: { label: 'queued', color: 'neutral' },
  publishing: { label: 'publishing', color: 'accent' },
  done: { label: 'published', color: 'success' },
  error: { label: 'failed', color: 'danger' },
}

export default function BulkPublishDetails() {
  const { jobs, summary: { total, published, failed } } = useBulkPublish()

  const settled = published + failed
  const value = total ? Math.round((settled / total) * 100) : 0

  return <>
    <div className='flex items-center gap-4 px-6 py-4'>
      <Progress value={value} color={failed ? 'warning' : 'accent'} />
      <span className='text-sm font-semibold uppercase whitespace-nowrap'>{settled} of {total}</span>
    </div>
    <ul>
      {jobs.map(({ id, title, slug, status, error, url }) => <li
        key={id}
        className='group flex items-center gap-3 px-6 py-3 border-t twy-border-base hover:twy-bg-base transition-colors'
      >
        <div className='flex-1 min-w-0'>
          <div className='truncate twy-text-base-accent'>{title ? `[#${id}] - ${title}` : `[#${id}]`}</div>
          <div className='text-sm font-semibold uppercase truncate'>/{slug}</div>
        </div>
        {status === 'done' && url ? <ButtonIcon
          content='View on site'
          onClick={() => window.open(url, '_blank')}
          className='mt-1 opacity-0 transition-opacity group-hover:opacity-100'
        >
          <Forward size={16} />
        </ButtonIcon> : null}
        {status === 'error' ? <DefaultTooltip content={error || 'Publish failed'}>
          <Badge variant='outline' color={STATUS.error.color} className='self-center'>{STATUS.error.label}</Badge>
        </DefaultTooltip> : <Badge variant='outline' color={STATUS[status].color} className='self-center'>
          {STATUS[status].label}
        </Badge>}
      </li>)}
    </ul>
  </>
}
